import { Warning } from '@phosphor-icons/react';

export default function CriticalRecoveryBanner({ recoveryStats }) {
  if (!recoveryStats?.aged_10_days) return null;
  const fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
  return (
    <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-300 rounded-lg p-4" data-testid="critical-review-card">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <Warning size={28} weight="fill" className="text-red-600" />
          <div>
            <div className="font-bold text-red-900">Quick Critical Review</div>
            <div className="text-sm text-red-700">
              <b>{recoveryStats.aged_10_days}</b> booking{recoveryStats.aged_10_days > 1 ? 's' : ''} pending ≥10 days • At risk: <b>{fmt.format(recoveryStats.at_risk_amount || 0)}</b>
            </div>
            <div className="text-xs text-red-600 mt-0.5">Opens pre-selected list — one-click bulk write-off ready</div>
          </div>
        </div>
        <a
          href="/admin/recovery-queue?auto=critical"
          className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-semibold"
          data-testid="critical-review-btn"
        >
          Review Now →
        </a>
      </div>
    </div>
  );
}
